export interface SizeOption {
  height?: number;
  width?: number;
  description?: string;
  pricing: {
    [qty: string]: number;
  };
}
export interface CustomPackagingOptionsMatrix {
  [type: string]: {
    label: string;
    description?: string;
    isCircular?: boolean;
    sizes: SizeOption[];
  };
}

export enum PackagingKind {
  FEATURED = 'FEATURED',
  CUSTOM = 'CUSTOM',
}

export interface BaseFeaturedPackagingCard {
  kind: PackagingKind;
  title: string;
  startingPointTitle: string;
  cardColor: string;
  textColor: string;
  options: CustomPackagingOptionsMatrix;
  image: string;
  exampleImages: string[];
}

export interface FeaturedPackagingCard extends BaseFeaturedPackagingCard {
  key: FeaturedPackagingCategory;
  categoryId: number;
  description: string;
  invoiceTitle: string;
  placementSubtitle?: string;
}

export interface FeaturedPackagingSupplierCard extends BaseFeaturedPackagingCard {
  supplierName: string;
  catalogItemId: number;
}

export interface FeaturedPackagingAttribute {
  key: FeaturedPackagingAttributeKey;
  title: string;
  subtitle?: string;
  linkText?: string;
}

export interface RegisterCustomPackagingParams {
  type: 'polymailers' | 'notecards' | 'stickers' | 'tissue paper' | 'shipping boxex';

  /** polymailers / notecards / stickers / tissue */
  size: string;
  quantity: number;

  /** stickers */
  stickersType: string;

  /** stickers / tissue */
  artworkUrl: string;

  /** polymailers / notecards */
  printSides: string;
  frontUrl: string;
  backUrl: string;

  /** shippingbox */
  shippingboxType: string;
  printOption: string;
  dielineUrl: string;

  /** all */
  description: string;
}

export type PackagingCard = FeaturedPackagingCard | FeaturedPackagingSupplierCard;

export enum FeaturedPackagingAttributeKey {
  TYPE = 'type',
  SIZE = 'size',
  QUANTITY = 'quantity',
  DESCRIPTION = 'description',
  PLACEMENTS = 'placements',
  COLORS = 'colors',
  PAPER_TYPE = 'paperType',
}

export enum PlacementOption {
  FRONT_ONLY = 'Front Only',
  FRONT_BACK = 'Front & Back',
}

export enum FeaturedPackagingCategory {
  STICKERS = 'stickers',
  POLYMAILERS = 'polymailers',
  TISSUE_PAPER = 'tissue-paper',
  NOTECARDS = 'notecards',
  SHIPPING_BOXES = 'shipping-boxes',
}
